import { createContext } from 'react';
import { TabsContext } from './types';

export default createContext<TabsContext>({} as TabsContext);
